import TwoFactorAuthDialog from "componets/two-factor-auth-dialog/two-factor-auth-dialog";

export default TwoFactorAuthDialog
